import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step9', 'Steps', {
	data() {
		return {
			hingeCount: 2,
			selectedHinge: 0,
			selectedHingeModel: 0,
			additionalHinge: false,
			hingeVrezka: false,
			hingeColor: null,
			radio2: [
				{ label: 'Да', value: 1, price: 0 },
				{ label: 'Нет', value: 0, price: 0 },
			],
			step9: null,
		};
	},
	props: ['latchModel'],
	created() {
		this.getDataStep();
	},
	watch: {
		latchModel() {
			this.selectedHinge = 0;
			this.selectedHingeModel = 0;
			this.getDataStep();
		},
		selectedHinge: function (val) {
			this.setPropPosition({
				hingeType: {
					id: this.step9.hinges[val].id,
					title: this.step9.hinges[val].title,
					image: this.step9.hinges[val].image,
				},
			});
		},
		additionalHinge: function (val) {
			if (val) {
				this.setPropPosition({
					hingeAdditional: { need: true, price: this.step9.hinges[this.selectedHinge].items[this.selectedHingeModel].price },
				});
			} else {
				this.setPropPosition({
					hingeAdditional: { need: false, price: 0 },
				});
			}
		},
		hingeVrezka(val) {
			this.radio2.forEach((item) => {
				if (item.value === val) this.setPropPosition({ hingeVrezka: item });
			});
		},
		hingeColor(val) {
			this.setPropPosition({ hingeColor: this.step9.hingeColors[val] });
		},
	},
	methods: {
		isDataStep: function () {
			return this.step9;
		},
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep9', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step9 = response.data.result;

					if (context.step9.hinges.length) {
						context.setPropPosition({
							hingeType: {
								id: context.step9.hinges[context.selectedHinge].id,
								title: context.step9.hinges[context.selectedHinge].title,
								image: context.step9.hinges[context.selectedHinge].image,
							},
						});
						if (context.step9.hinges[context.selectedHinge].items.length) {
							context.setPropPosition({
								hingeModel: {
									...context.step9.hinges[context.selectedHinge].items[context.selectedHingeModel],
									price: context.step9.hinges[context.selectedHinge].items[context.selectedHingeModel].price * 2,
								},
							});
						}
					}
				}
			});
		},
		setFirstPoints() {
			this.selectedHinge = 0;
			this.selectedHingeModel = 0;
			this.setPropPosition({
				hingeType: {
					id: this.step9.hinges[this.selectedHinge].id,
					title: this.step9.hinges[this.selectedHinge].title,
					image: this.step9.hinges[this.selectedHinge].image,
				},
			});

			if (this.step9.hinges[this.selectedHinge].items.length) {
				this.setPropPosition({
					hingeModel: {
						...this.step9.hinges[this.selectedHinge].items[this.selectedHingeModel],
						price: this.step9.hinges[this.selectedHinge].items[this.selectedHingeModel].price * 2,
					},
				});
			}
		},
		setActiveHinge(index) {
			if (this.selectedHinge === index) return;
			this.selectedHinge = index;
			this.setActiveHingeModel(0);
		},
		setActiveHingeModel(index) {
			this.selectedHingeModel = index;

			this.setPropPosition({
				hingeModel: {
					...this.step9.hinges[this.selectedHinge].items[this.selectedHingeModel],
					price: this.step9.hinges[this.selectedHinge].items[this.selectedHingeModel].price * 2,
				},
			});
		},
		setAdditionalHinge(val) {
			this.additionalHinge = val;
			if (this.additionalHinge) {
				this.hingeCount = 3;
			} else {
				this.hingeCount = 2;
			}
		},
		setHingeVrezka(val) {
			this.hingeVrezka = val;
		},
		setHingeColor(val) {
			this.hingeColor = val;
		},
	},
	template: `
<div class="config-block">
	<div class="config-block__inner" v-if="isDataStep()">
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Выбор петель</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="(slide, index) of step9.hinges">
					<SimpleItem :image="slide.image" :title="slide.title" :key="index" :class="{active: selectedHinge === index}"
						v-on:setActive="setActiveHinge(index)" />
				</div>
			</Swiper>
		</div>
		<div class="config-block__wrap mt-48" v-if="selectedHinge!==null">
			<div class="config-block__wrap-title">Модель петель</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="(slide, index) of step9.hinges[selectedHinge].items">
					<SimpleItem :image="slide.image" :title="slide.title" :price="slide.price" :availability="slide.availability"
						:priceType="2" :key="index" :class="{active: selectedHingeModel === index}"
						v-on:setActive="selectedHingeModel = index" />
				</div>
			</Swiper>
		</div>
		<!--
		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Врезка под петли</div>
			<div class="config-block__row flex">
				<RadioGroup :options="radio2" name="vrezka-for-hinge" :selected="radio2[1].value"
					v-on:selectedValue="setHingeVrezka" />
			</div>
		</div>-->
		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Количество петель</div>
			<div class="config-block__row flex">
				<inputDisabled :value="hingeCount" name="hinge_count" class="w-100p sm:w-50p" />
			</div>
		</div>
		<div class="config-block__wrap mt-48">
			<Checkbox name="door_additional_hinge" title="Добавить дополнительную петлю"
				v-on:setChecked="setAdditionalHinge">
		</div>
		<!--<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Цвет петли</div>
			<HingeCatalog :items="step9.hingeColors" v-on:modalItemSelect="setHingeColor" />
		</div>-->
	</div>
	<div v-else>
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Выбор петель</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="i of [1,2,3]">
					<PuSkeleton height="180px" />
				</div>
			</Swiper>
		</div>
		<div class="config-block__row flex">
			<PuSkeleton width="100px" height="24px" style="margin: 0 30px 0 0" />
			<PuSkeleton width="100px" height="24px" />
		</div>
		<!--
		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Количество петель</div>
			<div class="config-block__row flex">
				<PuSkeleton class="w-100p sm:w-50p" />
			</div>
		</div>
		<div class="config-block__wrap mt-48">
			<PuSkeleton class="w-100p sm:w-50p" />
		</div>
		<div class="config-block__wrap mt-48">
			<PuSkeleton height="60px" style="max-width:200px" />
		</div>
	</div>-->
</div>
`,
});
